import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Site } from '@classes/site';
// import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { SitePicture } from '@classes/site-picture';
const moment = _moment;
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/site';
  private basePathSitePicture = this.environment.apiUrl + '/sitePicture';

  public sites = new BehaviorSubject<Array<Site>>([]);

  lastUpdate: _moment.Moment;

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) {
    this.lastUpdate = moment();
  }

  getSites(forceRefresh?: boolean): Observable<Array<Site>> {
    if (this.sites.value.length && this.lastUpdate.isBefore(moment().add(this.environment.refreshListSecond, 'second')) && !forceRefresh) {
      return of(this.sites.value);
    }
    return this.http.get<Array<Site>>(this.basePath).pipe(
      map(m => {
        this.sites.next(m);
        this.lastUpdate = moment();
        return m;
      })
    );
  }

  getSite(id: string): Observable<Site> {
    return this.http.get<Site>(`${this.basePath}/${id}`);
  }

  createOrUpdateSite(site?: Site): Observable<Site> {
    if (site?.id) {
      //update
      const url = `${this.basePath}/${site?.id}`;
      return this.http.patch<any>(url,
        site).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        site
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteSite(siteId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${siteId}`;
    return this.http.delete(url);
  }

  getPictures(siteId: string): Observable<Array<SitePicture>> {
    return this.http.get<Array<SitePicture>>(`${this.basePathSitePicture}/${siteId}`);
  }

    deletePicture(id: string): Observable<any> {
      const baseUrl = this.basePathSitePicture;
      const url = `${baseUrl}/${id}`;
      return this.http.delete(url);
    }

  uploadPicture(
    siteId: string,
    formData: FormData
  ) {
    return this.http.post<any>(
      `${this.basePathSitePicture}/uploadPicture?siteId=${siteId}`,
      formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
